import { ReservationLog } from '../models';
import { CollectionQueryOptions } from '../types/';
import { useCollection } from './useCollection';

export function useReservationLogs(options?: CollectionQueryOptions) {
  return useCollection<ReservationLog>(
    'ReservationLogs',
    [],
    options?.sorting || { sortField: 'date', sortDirection: 'desc' },
    options?.pagination,
    options?.filters
  );
}
